"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModelStatus_1 = require("../../types/ModelStatus");
const Component_1 = __importDefault(require("../Component"));
class PlaylistsComponent extends Component_1.default {
    constructor(playlists) {
        super();
        this.playlists = playlists;
    }
    getTemplate() {
        const content = this.playlists.status === ModelStatus_1.ModelStatus.Success
            ? '<ul class="playlist__list"></ul>'
            : '<p>Loading ...</p>';
        return `
      <section class="playlist section" data-target="playlists">
        <h2 class="playlist__h2 title__h2">Плейлисты</h2>
        ${content}
      </section>
    `;
    }
}
exports.default = PlaylistsComponent;
